import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useMemo,
} from "react";
import useSocket from "../hooks/useSocket";
import { useSelector } from "react-redux";

const SoundContext = createContext();

export const useSoundContext = () => useContext(SoundContext);

export const SoundProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const { user, token } = useSelector((state) => state.auth);
  const backendURL =
    import.meta.env.MODE === "development"
      ? import.meta.env.VITE_BACKEND_URL
      : import.meta.env.VITE_BACKEND_URL_PROD;

  const handleDetectSoundIsPlaying = (shouldPlay) => {
    setIsPlaying(shouldPlay);
  };

  const subscriptionData = useMemo(
    () => ({
      event: "waiting-for-orders",
      data: 1234,
      unsubscribeEvent: "leaving-the-waiting-for-orders",
    }),
    []
  );

  const socket = useSocket(
    backendURL,
    "play-sound",
    handleDetectSoundIsPlaying,
    subscriptionData
  );

  useEffect(() => {
    if (user && token) {
      socket?.connect();
    } else {
      socket?.disconnect();
    }
  }, [user, token, socket]);

  return (
    <SoundContext.Provider value={{ isPlaying, setIsPlaying }}>
      {children}
    </SoundContext.Provider>
  );
};
